import { render } from "./Stocktaking.vue?vue&type=template&id=201db2d3&scoped=true"
import script from "./Stocktaking.vue?vue&type=script&lang=js"
export * from "./Stocktaking.vue?vue&type=script&lang=js"

import "./Stocktaking.vue?vue&type=style&index=0&id=201db2d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201db2d3"]])

export default __exports__